import {
  Collection,
  getPracticeConsentFormsCollection,
  getPracticeConsentFormsCollectionPath,
  Template,
  templateCollections,
  TemplateKey,
  templateKeyToCollection,
} from '@hb/shared'
import { useMemo } from 'react'
import { useCollection } from '../../../collections/hooks/useCollection'
import { useApp } from '../../../contexts'
import { useSelectedPractice } from '../../../hooks'

export const useTemplateCollection = (type: TemplateKey) => {
  const { appName } = useApp()
  const { id: practiceId } = useSelectedPractice()
  return useMemo(() => {
    if (appName === 'app' || type !== 'consentForm') return templateCollections[type]
    if (!practiceId) return null
    return getPracticeConsentFormsCollection(practiceId)
  }, [practiceId, type, appName])
}
export const useTemplates = (type: TemplateKey) => {
  const collection = useTemplateCollection(type)
  return useCollection(collection as Collection<Template>)
}

export const useTemplatesCollectionPath = (type: TemplateKey) => {
  const { appName } = useApp()
  const { id: practiceId } = useSelectedPractice()
  return useMemo(() => {
    if (appName === 'app' || type !== 'consentForm') return templateKeyToCollection[type]
    if (!practiceId) return null
    return getPracticeConsentFormsCollectionPath(practiceId)
  }, [practiceId, type, appName])
}
